import {observer} from 'mobx-react';
import React from 'react';
import {InsigniaCustomization} from '../../../i';
import s from '../../../s';

type InsigniaListProps = {
    fpcId: number;
    collapsed: boolean;
    collapsedNumber: number;
    save: (id: number) => void;
    isModal?: boolean;
};

export const InsigniaList = observer((props: InsigniaListProps) => {
    const {fpcId, isModal, collapsed, collapsedNumber, save} = props;

    return (
        <div
            className="ins-prod"
            style={{justifyContent: isModal ? 'space-around' : ''}}
            role="listbox"
            aria-label="Select Insignia"
        >
            {s.prod.insignias
                .filter(m => (s.ui.linen && !m.title.toLowerCase().includes('embossed')) || !s.ui.linen)
                // .filter(
                //     m =>
                //         (m.fpc_id === fpcId || fpcId === -2) &&
                //         ((s.pcs.ins_gold_allowed && m.ins_color === 'gold') || (s.pcs.ins_silver_allowed && m.ins_color === 'silver') || (s.pcs.ins_black_allowed && m.ins_color === 'black') || (m.ins_color !== 'black' && m.ins_color !== 'silver' && m.ins_color !== 'gold')),
                // )
                .filter(m => (!s.prod.IsCAF && m.gradSchoolId === s.currentGradSchoolID) || s.prod.IsCAF)
                .slice(0, collapsedNumber)
                .map((m: InsigniaCustomization, i: number) => (
                    <div
                        data-bs-toggle={window.innerWidth > 1200 ? 'popover' : ''}
                        data-bs-placement="top"
                        data-bs-html="true"
                        data-bs-trigger="hover focus"
                        data-bs-content={`<div class="prod-img-zoom" style="background-color:#${s.ui.color_mat1}"><div style="background-color:#${s.ui.color_mat1}"><img loading="lazy" src="https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_220.png" alt="" /></div></div>`}
                        title={m.title}
                        role="option"
                        id={`ins-${m.id}`}
                        key={m.id}
                        data-id={m.id}
                        aria-label={`Select ${m.title} insignia`}
                        className={`cust-entity${s.pcs.insignia_id === m.id ? ' active' : ''}${!collapsed ? ' active-bold' : ''}`}
                        onClick={() => save(m.id)}
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                save(m.id);
                            }
                        }}
                        data-img={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_220.png`}
                        tabIndex={0}
                    >
                        <div
                            data-id={m.id}
                            className="ins"
                            style={{backgroundColor: `#${s.ui.color_mat1}`}}
                        >
                            <img
                                data-id={m.id}
                                loading="lazy"
                                src={`https://${s.Portal.CDNDomain}/images/entities/insignia/v2/${m.name.toLowerCase()}_90.png`}
                                width="90"
                                alt={m.title}
                            />
                        </div>
                        <div
                            className="title"
                            data-id={m.id}
                        >
                            {m.title}
                        </div>
                    </div>
                ))}
        </div>
    );
});
